import { render, staticRenderFns } from "./OneShopRow.vue?vue&type=template&id=3b221775&scoped=true&"
import script from "./OneShopRow.vue?vue&type=script&lang=js&"
export * from "./OneShopRow.vue?vue&type=script&lang=js&"
import style0 from "./OneShopRow.vue?vue&type=style&index=0&id=3b221775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b221775",
  null
  
)

export default component.exports